import React from 'react';
import Routes from '../../constants/Routes';

export const LinkSuccess = () =>
  <div className="mb-0 mt-4 alert alert-success alert-dismissible fade show" role="alert">
    <button type="button" className="close" aria-label="Close">
      <span aria-hidden="true">×</span>
    </button>
    <i className="material-icons alert-icon" aria-hidden="true">check</i>
    <b>Thank you: </b>Your Lone Wolf Account has been linked to your brokerage.
  </div>;

export const LinkConflict = ({ invitationId }) =>
  <div className="mb-0 mt-4 alert alert-danger alert-dismissible fade show" role="alert">
    <p className="text-dark d-block w-100 text-center">This username is taken.	<br />Already Have a Lone Wolf Account? <a href={Routes.LINK_ACCOUNT.replace(":id", invitationId)}>Link Account</a></p>
  </div>;


export const LinkGenericFailed = () =>
  <div className="mb-0 mt-4 alert alert-danger alert-dismissible fade show" role="alert">
    <p className="text-dark d-block w-100 text-center">An error has occurred, and your account has not been created.
    Please try again, and contact your administrator if the issue persists.
    </p>
  </div>;

export const InviteLandingGenericFailed = ({ invitationId }) =>
  <div className="mb-0 mt-4 alert alert-danger alert-dismissible fade show" role="alert">
    <p className="text-dark d-block w-100 text-center">An error has occurred, and your account has not been created.
    Please try again, and contact your administrator if the issue persists.	<br />Already Have a Lone Wolf Account? <a href={Routes.LINK_ACCOUNT.replace(":id", invitationId)}>Link Account</a>
    </p>
  </div>;


export const LinkAuthFailed = () =>
  <div className="mb-0 mt-4 alert alert-danger alert-dismissible fade show" role="alert">
    <p className="text-dark d-block w-100 text-center">Invalid email address or password. Please try again.</p>
  </div>;

export const InvalidInvitationMessage = () =>
  <div className="mb-0 mt-4 alert alert-danger alert-dismissible fade show" role="alert">
      <p className="text-dark d-block w-100 text-center">
          This invitation is no longer valid. Please contact your system administrator.
      </p>
  </div>;
